export interface FireOnceGuard {
	/** True once the event has fired for this surface's page load. */
	hasFired: () => boolean;
	/** Marks the event as fired. Called only after a positive match emits. */
	markFired: () => void;
	/** Resets the guard (e.g. on remount / navigation to a new page). */
	reset: () => void;
}

/**
 * A trivial in-memory, fire-once-per-page-load guard. There is deliberately no
 * session concept, storage, or cross-load dedup — "trigger the experience once"
 * throttling belongs to the future experiment, not this preanalysis
 * (STARB-3769). Its main job is to swallow the duplicate emits that the 1000 ms
 * content debounce would otherwise produce.
 */
export const createFireOnceGuard = (): FireOnceGuard => {
	let fired = false;
	return {
		hasFired: () => fired,
		markFired: () => {
			fired = true;
		},
		reset: () => {
			fired = false;
		},
	};
};
